<template>
  <dx-offer-intro product="small-business" />
</template>

<script>
import DxOfferIntro from '~/domains/offer/components/DX-OfferIntro'

export default {
  name: 'SmallBusinessIntro',
  components: {
    DxOfferIntro,
  },
  layout: 'website',
  // maybe use a dynamic layout here some day?
  // layout: ({ store }) => (store.getters.isLoggedIn ? 'default' : 'website'),
  transition: 'none',
  meta: {
    isPublic: true,
    trackingId: 'dextra.unternehmensrechtsschutz.small-business.antragsstrecke',
    trackingGroup: ['rechtsschutz', 'unternehmensrechtsschutz'],
  },
  nuxtI18n: {
    paths: {
      de: '/unternehmensrechtsschutz/small-business/antragsstrecke/',
      fr:
        '/protection-juridique-entreprise/small-business/formulaire-de-demande/',
    },
  },
}
</script>
